<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="option_breadcrumb" />
    </div>

    <div class="header">
      <h1 class="overlay">OPTION PROGRAM</h1>
      <!--      <img src="@/assets/images/Podohotel/hotspring_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="container">
      <div class="row d-flex justify-content-center">
        <!--        <div>-->
        <!--          <img src="@/assets/images/pleisure/pleisure_headerimage.jpg" />-->
        <!--        </div>-->
        <div class="col-lg-12 rowSpace"></div>
        <div class="text-center col-lg-12 mainTitle">{{ $t('therapy_title') }}</div>
        <div class="mainTitleLine">
          <hr />
        </div>
        <div class="col-lg-12 text-center mainIntro">{{ $t('therapy_subtitle') }}</div>
        <div class="rowSpace"></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
        </div>
        <div class="rowSpace"><hr /></div>
        <GallerySlideCarousels :slides="main_slides" :slide-count="4" :thumb-slide-width="45" />
      </div>
    </div>
    <div class="container subContainer">
      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 mainInfo">
          <div class="subDetail" v-html="$t('therapy_desc')"></div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('therapy_program_title') }}</div>

          <table class="col-lg-12 table table-bordered subTable">
            <thead>
              <tr>
                <td style="width: 40%">{{ $t('therapy_table_tr1_td1') }}</td>
                <td style="width: 30%">{{ $t('therapy_table_tr1_td2') }}</td>
                <td style="width: 30%">{{ $t('therapy_table_tr1_td3') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('therapy_table_tr2_td1') }}</td>
                <td>{{ $t('therapy_table_tr2_td2') }}</td>
                <td>{{ $t('therapy_table_tr2_td3') }}</td>
              </tr>
            </tbody>
          </table>
          <div class="etcDetail">{{ $t('therapy_table_desc') }}</div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('therapy_combi_title') }}</div>
          <ol>
            <li>{{ $t('therapy_combi_desc1') }}</li>
            <li>{{ $t('therapy_combi_desc2') }}</li>
            <li>{{ $t('therapy_combi_desc3') }}</li>
            <li>{{ $t('therapy_combi_desc4') }}</li>
            <li>{{ $t('therapy_combi_desc5') }}</li>
            <li>{{ $t('therapy_combi_desc6') }}</li>
          </ol>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('therapy_reserve_title') }}</div>
          <ol>
            <li>{{ $injectEmails($t('therapy_reserve_desc1')) }}</li>
            <li>{{ $t('therapy_reserve_desc2') }}</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import GallerySlideCarousels from '@/components/GallerySlideCarousels';

export default {
  name: 'Sutherapy',
  data() {
    return {
      isLang: 0,
      option_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS',
        present: this.$t('breadcrumb'),
      },
      main_slides: [
        {image: require('@/assets/images/pleisure/option/sutherapy_01.jpg')},
        {image: require('@/assets/images/pleisure/option/sutherapy_02.jpg')},
        {image: require('@/assets/images/pleisure/option/sutherapy_03.jpg')},
        {image: require('@/assets/images/pleisure/option/sutherapy_04.jpg')},
      ],
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }
      this.program_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  components: {Breadcrumb, GallerySlideCarousels},
};
</script>

<style scoped lang="scss">
td {
  vertical-align: middle;
}
li {
  list-style-type: square;
  font-size: 0.9rem;
}

.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
.mainTitle {
  font-weight: 800;
  font-size: 2rem;
  letter-spacing: -0.1rem;
}
.mainTitleLine {
  width: 10%;
  > hr {
  }
}
.mainIntro {
  word-break: keep-all;
}
.buttonArea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .resserve-button {
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: #524a3d;
    color: #fff;
  }
  .prev-button {
    justify-content: center;
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: white;
    color: #000;
    border: 1px solid black;
  }
}
.subContainer {
  width: 100%;
}
.mainInfo {
  padding: 1rem;
  width: 100%;
  height: 100%;
  > div {
    line-height: 1.5rem;
    font-size: 1rem;
  }
}
.serviceArea {
  padding: 1rem;
  > span {
    font-size: 0.8rem;
  }
}
.subTitle {
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.subDetail {
  font-size: 0.9rem;
  padding-left: 1rem;
  word-break: keep-all;
}
.etcDetail {
  font-size: 0.8rem;
  padding-left: 1rem;
  color: #616161;
}
.subTable {
  > thead {
    background-color: #eaeaea;

    > tr > td {
      width: 50%;
      text-align: center;
      font-weight: 600;
    }
  }
  > tbody {
    > tr > td {
      text-align: center;
      font-size: 0.9rem;
    }
  }
  margin-bottom: 0.5rem;
}

.rowSpace {
  width: 100%;
  height: 2rem;
  > hr {
  }
}

@media (min-width: 992px) {
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/common/option_headerimage.jpg');
  }
  .web {
    display: block;
  }
  .mobile {
    display: none;
  }
  .tHeader {
    font-size: 1.1rem;
  }
  .tBody {
    font-size: 1rem;
  }
}
@media (max-width: 992px) {
  .headerimage {
  }
  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: bold;
    }
  }
  .headerimage {
    display: none;
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "옵션 프로그램",
    "therapy_title": "수(水) 테라피",
    "therapy_subtitle": "돔 형식의 아쿠아 메디테이션 온수 풀 안에서 진행하는 스트레칭·지압 릴렉싱 프로그램",
    "prev_button": "이전",
    "therapy_desc": "사람은 태어나기 전, 어머니의 뱃속에서 가장 안전하고 편안하게 10개월을 보냅니다.<br/>이러한 어머니의 자궁을 형상화한 돔 형식의 아쿠아 메디테이션 풀에서 진행되는 수 테라피는 부유기를 이용하여 몸을 물 위에 띄운 상태에서 스트레칭과 지압을 통한 심신의 안정과 신체의 긴장 완화, 스트레스 해소, 우울감 완화와 불면증에도 효과적인 프로그램입니다.",
    "therapy_program_title": "운영 프로그램",
    "therapy_table_tr1_td1": "프로그램",
    "therapy_table_tr1_td2": "옵션",
    "therapy_table_tr1_td3": "요금(2인 기준)",
    "therapy_table_tr2_td1": "수(水) 테라피",
    "therapy_table_tr2_td2": "40분",
    "therapy_table_tr2_td3": "150,000 ~",
    "therapy_table_desc": "※ P-Leisure 메인프로그램 이용 시 적용되는 특별가 입니다.",
    "therapy_combi_title": "결합 가능한 P-Leisure 메인 프로그램",
    "therapy_combi_desc1": "프라이빗 럭셔리요트",
    "therapy_combi_desc2": "챌린저 골프",
    "therapy_combi_desc3": "노블승마",
    "therapy_combi_desc4": "제주어부",
    "therapy_combi_desc5": "해피투게더",
    "therapy_combi_desc6": "제주 숲토리텔링 투어",
    "therapy_reserve_title": "예약문의 및 상담",
    "therapy_reserve_desc1": "064-793-7070, 010-5328-7050, [[EMAIL:leisure]]",
    "therapy_reserve_desc2": "월~금(공휴일 제외) 09:00 ~ 17:30 (점심시간 12:00 ~ 13:00)"
  },
  "en": {
    "breadcrumb": "Option Program",
    "therapy_title": "Water Therapy",
    "therapy_subtitle": "Dome-shaped aqua mediation hot pool offers a stretching and acupressure relaxing program.",
    "prev_button": "Previous",
    "therapy_desc": "We spend the safest and most comfortable 10 months in the mother's womb before we are born. Water Therapy, which takes place in a dome-shaped aqua meditation pool which embodies the mother's womb, provides stretching and acupressure while floating your body in the water. It is an effective program for stabilizing the mind and body, relaxing your body, relieving stress, and even relieving depression and insomnia.",
    "therapy_program_title": "Program",
    "therapy_table_tr1_td1": "Program",
    "therapy_table_tr1_td2": "Option",
    "therapy_table_tr1_td3": "Fare(2 people)",
    "therapy_table_tr2_td1": "Water Therapy",
    "therapy_table_tr2_td2": "40 min.",
    "therapy_table_tr2_td3": "KRW 150,000 ~",
    "therapy_table_desc": "※ Special price for P-Leisure users",
    "therapy_combi_title": "Combinable programs",
    "therapy_combi_desc1": "private luxury yacht",
    "therapy_combi_desc2": "challenger golf",
    "therapy_combi_desc3": "noble riding",
    "therapy_combi_desc4": "Jeju fisherman",
    "therapy_combi_desc5": "Happytogether",
    "therapy_combi_desc6": "Jeju forest-ory tour",
    "therapy_reserve_title": "Reservation",
    "therapy_reserve_desc1": "064-793-7070, 010-5328-7050, [[EMAIL:leisure]]",
    "therapy_reserve_desc2": "MON~Sun (Excluding public holidays) 09:00 ~17:30 (Lunch 12:00 ~13:00)"
  },
  "ja": {
    "breadcrumb": "옵션 프로그램",
    "therapy_title": "수(水) 테라피",
    "therapy_subtitle": "돔 형식의 아쿠아 메디테이션 온수 풀 안에서 진행하는 스트레칭·지압 릴렉싱 프로그램",
    "prev_button": "이전",
    "therapy_desc": "사람은 태어나기 전, 어머니의 뱃속에서 가장 안전하고 편안하게 10개월을 보냅니다.<br/>이러한 어머니의 자궁을 형상화한 돔 형식의 아쿠아 메디테이션 풀에서 진행되는 수 테라피는 부유기를 이용하여 몸을 물 위에 띄운 상태에서 스트레칭과 지압을 통한 심신의 안정과 신체의 긴장 완화, 스트레스 해소, 우울감 완화와 불면증에도 효과적인 프로그램입니다.",
    "therapy_program_title": "운영 프로그램",
    "therapy_table_tr1_td1": "프로그램",
    "therapy_table_tr1_td2": "옵션",
    "therapy_table_tr1_td3": "요금(2인 기준)",
    "therapy_table_tr2_td1": "수(水) 테라피",
    "therapy_table_tr2_td2": "40분",
    "therapy_table_tr2_td3": "150,000 ~",
    "therapy_table_desc": "※ P-Leisure 메인프로그램 이용 시 적용되는 특별가 입니다.",
    "therapy_combi_title": "결합 가능한 P-Leisure 메인 프로그램",
    "therapy_combi_desc1": "프라이빗 럭셔리요트",
    "therapy_combi_desc2": "챌린저 골프",
    "therapy_combi_desc3": "노블승마",
    "therapy_combi_desc4": "제주어부",
    "therapy_combi_desc5": "해피투게더",
    "therapy_combi_desc6": "제주 숲토리텔링 투어",
    "therapy_reserve_title": "예약문의 및 상담",
    "therapy_reserve_desc1": "064-793-7070, 010-5328-7050, [[EMAIL:leisure]]",
    "therapy_reserve_desc2": "월~금(공휴일 제외) 09:00 ~ 17:30 (점심시간 12:00 ~ 13:00)"
  }
}
</i18n>
